import React, { useState } from 'react';
import { X, Loader2 } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import '../OTASignupForm.css';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const OTASignupForm = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    playerName: '',
    age: '',
    parentName: '',
    email: '',
    phone: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${API_URL}/api/ota-signups`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          player_name: formData.playerName,
          age: parseInt(formData.age),
          parent_name: formData.parentName,
          email: formData.email,
          phone: formData.phone
        }),
      });

      const data = await response.json();

      if (data.success) {
        setSubmitted(true);
        setTimeout(() => {
          setSubmitted(false);
          setFormData({
            playerName: '',
            age: '',
            parentName: '',
            email: '',
            phone: ''
          });
          onClose();
        }, 3000);
      } else {
        setError(data.message || 'Failed to submit. Please try again.');
      }
    } catch (err) {
      if (process.env.NODE_ENV === 'development') console.error('OTA Signup Error:', err);
      setError('Network error. Please check your connection and try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="ota-signup-overlay" onClick={onClose}>
      <div className="ota-signup-modal" onClick={(e) => e.stopPropagation()}>
        <Card className="signup-card">
          <CardHeader>
            <div className="modal-header">
              <CardTitle className="modal-title">Sign Up for OTA Training</CardTitle>
              <button className="close-button" onClick={onClose}>
                <X size={24} />
              </button>
            </div>
          </CardHeader>
          <CardContent>
            {!submitted ? (
              <form onSubmit={handleSubmit} className="signup-form">
                {error && (
                  <div className="form-error">
                    {error}
                  </div>
                )}
                <div className="form-group">
                  <label htmlFor="playerName">Player Name *</label>
                  <input
                    type="text"
                    id="playerName"
                    name="playerName"
                    value={formData.playerName}
                    onChange={handleChange}
                    required
                    placeholder="Enter player's full name"
                    disabled={loading}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="age">Player Age *</label>
                  <input
                    type="number"
                    id="age"
                    name="age"
                    value={formData.age}
                    onChange={handleChange}
                    required
                    min="5"
                    max="18"
                    placeholder="Enter age"
                    disabled={loading}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="parentName">Parent/Guardian Name *</label>
                  <input
                    type="text"
                    id="parentName"
                    name="parentName"
                    value={formData.parentName}
                    onChange={handleChange}
                    required
                    placeholder="Enter your full name"
                    disabled={loading}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="your.email@example.com"
                    disabled={loading}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Phone Number *</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    placeholder="(XXX) XXX-XXXX"
                    disabled={loading}
                  />
                </div>

                <div className="form-actions">
                  <Button type="submit" className="btn-primary" disabled={loading}>
                    {loading ? (
                      <>
                        <Loader2 className="animate-spin mr-2" size={18} />
                        Submitting...
                      </>
                    ) : (
                      'Submit Registration'
                    )}
                  </Button>
                  <Button type="button" className="btn-secondary" onClick={onClose} disabled={loading}>
                    Cancel
                  </Button>
                </div>
              </form>
            ) : (
              <div className="success-message">
                <div className="success-icon">✓</div>
                <h3>Registration Successful!</h3>
                <p>Thank you for signing up for OTA training. We'll contact you with more details soon.</p>
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default OTASignupForm;